import { Injectable } from "@angular/core";
import { EnvService } from '../environments/environment.factory';
import { NgxIndexedDB } from "ngx-indexed-db";

@Injectable()
export class DatabaseHelper {
    public readonly MONSTER_DATABASE_NAME: string = "MONSTERS";
    public readonly MONSTER_DATABASE_VERSION: number = 1;
    private _environment: any;

    constructor(
        private env: EnvService
    ) {
        this._environment = env;
    }


  public getMonsterDatabase(): Promise<NgxIndexedDB> {
    let database = new NgxIndexedDB("database", this.MONSTER_DATABASE_VERSION);

    return database.openDatabase(this.MONSTER_DATABASE_VERSION, evt => {
      let objectStore = evt.currentTarget.result.createObjectStore(this.MONSTER_DATABASE_NAME, { autoIncrement: false })
    }).then(evt => {
      return Promise.resolve(database);
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/databaseHelper.service.ts